import { render, staticRenderFns } from "./BulkSetStatusModal.vue?vue&type=template&id=fa32e8d6&scoped=true&lang=pug"
import script from "./BulkSetStatusModal.vue?vue&type=script&lang=js"
export * from "./BulkSetStatusModal.vue?vue&type=script&lang=js"
import style0 from "./BulkSetStatusModal.vue?vue&type=style&index=0&id=fa32e8d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa32e8d6",
  null
  
)

export default component.exports